/** Tenant configuration readiness, not a live cloud health probe. */
export interface DocumentSupport {
  readonly available: boolean;
}

export const DOCUMENT_SUPPORT_SETUP_MESSAGE =
  "Document support needs to be set up by an admin.";

export function documentUploadDisabledReason(
  support: DocumentSupport | undefined,
  isError: boolean,
): string | null {
  if (isError) return "Couldn't check document support. Try again.";
  if (!support) return "Checking document support…";
  return support.available ? null : DOCUMENT_SUPPORT_SETUP_MESSAGE;
}
